"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PopoverLinkText = exports.PopoverItem = exports.PopoverItemAsRouterLink = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _StyledLink = _interopRequireDefault(require("../StyledLink"));

var _StyledTypography = require("../StyledTypography");

var _excluded = ["fullWidth", "forceHover", "hoverBlue"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SPACING_FROM_PARENT = '14';
var ARROW_HEIGHT = '12';

var StyledPopover = _styledComponents["default"].span.withConfig({
  displayName: "Elements__StyledPopover",
  componentId: "sc-10lxorz-0"
})(["display:inline-flex;position:relative;width:auto;max-width:512px;min-width:24px;flex-direction:column;", " ", " .arrow{position:absolute;top:calc(", ");left:calc(", " - 12px);transform:", ";visibility:", ";z-index:2;width:24px;height:12px;}.popover-wrapper{position:absolute;visibility:", ";min-height:24px;max-height:", "px;max-width:inherit;min-width:inherit;top:calc(", ");box-shadow:0px 0px 4px rgba(0,0,0,0.08),0px 4px 12px rgba(0,0,0,0.16);border-radius:4px;width:250px;z-index:", ";overflow:hidden;display:flex;flex-direction:column;align-self:", ";background-color:white;", " ", "}.popover{display:flex;align-items:center;flex-direction:column;padding:8px 0px;overflow-y:auto;width:inherit;}", " ", " ", " ", ""], function (props) {
  return props.popoverParentHeight && (0, _styledComponents.css)(["height:", "px;"], props.popoverParentHeight);
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["width:100%;"]);
}, function (props) {
  return props.isBelow ? '100% + 2px' : "-".concat(ARROW_HEIGHT, "px - 2px");
}, function (props) {
  return props.arrowLeft ? "".concat(props.arrowLeft, "px") : '50%';
}, function (props) {
  return props.isBelow ? 'none' : 'rotate(180deg)';
}, function (props) {
  return props.show && props.arrow ? 'visible' : 'hidden';
}, function (props) {
  return props.show ? 'visible' : 'hidden';
}, function (props) {
  return props.popoverMaxHeight;
}, function (props) {
  return props.isBelow ? '100% + 14px' : "-".concat(props.wrapperHeight, "px - ").concat(SPACING_FROM_PARENT, "px");
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.alignment ? props.alignment : 'start';
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["width:100%;"]);
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", "px;"], props.width);
}, function (props) {
  return props.position === 'top' && (0, _styledComponents.css)([".popover-wrapper{top:auto;bottom:calc(100% + ", "px);}.arrow{top:auto;bottom:calc(100% + ", "px - ", "px);transform:rotate(180deg);}"], SPACING_FROM_PARENT, SPACING_FROM_PARENT, ARROW_HEIGHT);
}, function (props) {
  return props.position === 'bottom-left' && (0, _styledComponents.css)([".popover-wrapper{left:unset;right:-8px;}.arrow{left:unset;right:", "px;}"], 0 + props.arrowOffsetFromEdge);
}, function (props) {
  return props.position === 'left' && (0, _styledComponents.css)([".popover-wrapper{top:-50%;right:calc(100% + ", "px);}.arrow{top:calc(50% - ", "px);left:-20px;transform:rotate(90deg);}"], SPACING_FROM_PARENT, ARROW_HEIGHT / 2);
}, function (props) {
  return props.position === 'right' && (0, _styledComponents.css)([".popover-wrapper{top:-50%;left:calc(100% + ", "px);}.arrow{top:calc(50% - ", "px);left:calc(100% - 4px);transform:rotate(270deg);}"], SPACING_FROM_PARENT, ARROW_HEIGHT / 2);
});

var popoverItemStyle = (0, _styledComponents.css)(["width:", ";padding:", " 0;", ""], function (props) {
  return props.fullWidth && '100%';
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.hoverBlue && (0, _styledComponents.css)(["margin-left:-", ";margin-right:-", ";padding-left:", ";padding-right:", ";&:hover,&:focus{background-color:", ";outline:none;", ",", "{color:", ";}", "{svg .inline_svg_icon__fill,svg path{fill:", ";}}}"], props.theme.spacingSm, props.theme.spacingSm, props.theme.spacingSm, props.theme.spacingSm, props.theme.bgColorMenuHover, _StyledTypography.Paragraph, _StyledLink["default"], props.theme.fontColorWhite, _StyledLink["default"], props.hoverFillColor ? props.hoverFillColor : props.theme.iconColorWhite);
});

var FilteredLink = function FilteredLink(_ref) {
  var fullWidth = _ref.fullWidth,
      forceHover = _ref.forceHover,
      hoverBlue = _ref.hoverBlue,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, props);
};

var PopoverItemAsRouterLink = (0, _styledComponents["default"])(FilteredLink).withConfig({
  displayName: "Elements__PopoverItemAsRouterLink",
  componentId: "sc-10lxorz-1"
})(["", ""], popoverItemStyle);
exports.PopoverItemAsRouterLink = PopoverItemAsRouterLink;

var PopoverItem = _styledComponents["default"].div.withConfig({
  displayName: "Elements__PopoverItem",
  componentId: "sc-10lxorz-2"
})(["", ""], popoverItemStyle);

exports.PopoverItem = PopoverItem;
var PopoverLinkText = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "Elements__PopoverLinkText",
  componentId: "sc-10lxorz-3"
})(["padding-left:", ";margin-left:", ";", ""], function (props) {
  return props.textOnlyMenu && '0' || props.theme.spacingLg;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return (props.withIcon || props.iconSrc) && (0, _styledComponents.css)(["padding-left:", ";margin-left:0;"], props.theme.spacingSm);
});
exports.PopoverLinkText = PopoverLinkText;
var _default = StyledPopover;
exports["default"] = _default;